import type { Event, EventHint } from "@sentry/types";

const abortError = (event: Event, hint: EventHint): Event | null => {
  const error = hint.originalException;

  const isAbortErrorString = typeof error === "string" && error.startsWith("AbortError");
  const isAbortError =
    typeof error === "object" && error !== null && "name" in error && error.name === "AbortError";
  const isAbortErrorType = event.exception?.values?.[0]?.type === "AbortError";

  if (isAbortErrorString || isAbortError || isAbortErrorType) return null;

  return event;
};

export { abortError };
